{
    "coordinates": [
        50.01998375755653,
        10.668270609021704
    ],
    "tooltip": "Bromacker Quarry",
    "title": "Tambach Formation (Bromacker)",
    "country": "Germany",
    "period": "Permian",
    "alt": "TODO"
}
